// Memoized TaskUIProvider context value for TaskListBase.
import { useMemo } from 'react';

export function useTaskListUiContextValue({
  view,
  indentationType,
  showBreadcrumbs,
  plannedParentIds,
  waitingForParentIds,
  isFocused,
  selectedTaskIds,
  isMultiSelectActive,
  duplicateOrderKeyTaskIds,
  handleRebalance,
  handleTaskClick,
  handleSelectSingle,
  handleBulkLongPress,
  handleStartAddingSubtask,
  onBeforeToggleComplete,
  dragEnabled,
  listId,
  focusOwnerId,
  addSubtaskOnParentsOnly,
  menuSurface,
  dragType,
  disableRowNavigate,
  itemTabIndex,
  onboardingHighlightTaskId = null,
  topActionableTaskId = null,
}) {
  return useMemo(
    () => ({
      view,
      indentationType,
      showBreadcrumbs,
      plannedParentIds,
      waitingForParentIds,
      isListFocused: isFocused,
      selectedTaskIds,
      isMultiSelectActive,
      duplicateOrderKeyTaskIds,
      onRebalance: handleRebalance,
      onTaskClick: handleTaskClick,
      onSelectSingle: handleSelectSingle,
      onToggleInSelection: handleBulkLongPress,
      onStartAddingSubtask: handleStartAddingSubtask,
      onBeforeToggleComplete,
      dragEnabled,
      listId,
      focusOwnerId,
      addSubtaskOnParentsOnly,
      menuSurface,
      dragType,
      disableRowNavigate,
      itemTabIndex,
      onboardingHighlightTaskId,
      topActionableTaskId,
    }),
    [
      view,
      indentationType,
      showBreadcrumbs,
      plannedParentIds,
      waitingForParentIds,
      isFocused,
      selectedTaskIds,
      isMultiSelectActive,
      duplicateOrderKeyTaskIds,
      handleRebalance,
      handleTaskClick,
      handleSelectSingle,
      handleBulkLongPress,
      handleStartAddingSubtask,
      onBeforeToggleComplete,
      dragEnabled,
      listId,
      focusOwnerId,
      addSubtaskOnParentsOnly,
      menuSurface,
      dragType,
      disableRowNavigate,
      itemTabIndex,
      onboardingHighlightTaskId,
      topActionableTaskId,
    ],
  );
}
